<section class="toolbar">
  <div class="left-side">

    <nz-select [(ngModel)]="startNodeId"
               (ngModelChange)="onStarterNodeSelectionChange($event)"
               nzPlaceHolder="Filter by workflow"
               nzAllowClear
               [nzShowSearch]="true"
               nzNotFoundContent="There is no workflow to select"
               class="starter-node-select">
      <nz-option *ngFor="let node of starterNodes"
                 [nzValue]="node.id"
                 [nzLabel]="node.name"></nz-option>
    </nz-select>

    <rappider-button-list [buttons]="DiagramButtonConfig"
                          [direction]="'horizontal'"
                          [gap]="'10px'"
                          (buttonClick)="onButtonClick($event)">
    </rappider-button-list>

    <button nz-button
            nzType="default"
            nzSize="small"
            class="zoom-button">

      <i class="fa-regular fa-magnifying-glass-minus"
         (click)="zoomOut()"></i>

      <rappider-slider class="zoom-slider"
                       nz-tooltip
                       nzTooltipTitle="You can click here or use your mouse wheel to zoom in and out."
                       [ngModel]="zoomLevel"
                       [minRange]="25"
                       [maxRange]="300"
                       [marks]="zoomMarks"
                       [step]="25"
                       (ngModelChange)="onZoomLevelChanged($event)"></rappider-slider>
      <span>{{ zoomLevel }}%</span>

      <i class="fa-regular fa-magnifying-glass-plus"
         (click)="zoomIn()"></i>
    </button>

  </div>

  <div class="right-side">

    <rappider-icon [name]="WorkflowDiagramInfoIcon.name"
                   [color]="WorkflowDiagramInfoIcon.color"
                   (click)="infoModalVisibility()"></rappider-icon>
    <rappider-icon [name]="menuVisibility ? MenuUnfoldIcon.name : MenuFoldIcon.name"
                   [type]="MenuFoldIcon.type"
                   (click)="onChangeMenuVisibility()"></rappider-icon>
  </div>
</section>
<rappider-modal [visible]="infoModalVisible"
                [title]="WorkflowDiagramInfoModalConfig.title"
                [okText]="WorkflowDiagramInfoModalConfig.okText"
                [cancelText]="WorkflowDiagramInfoModalConfig.cancelText"
                [footer]="WorkflowDiagramInfoModalConfig.footer"
                (cancelClick)="infoModalVisibility()">
  <nz-collapse nzGhost>
    <nz-collapse-panel *ngFor="let InfoModalContent of WorkflowDiagramInfoModalContents"
                       [nzHeader]="InfoModalContent.name">
      <p>{{ InfoModalContent.content }}</p>
    </nz-collapse-panel>
  </nz-collapse>
</rappider-modal>
